import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

export const HeaderSkeleton = () => (
  <ContentLoader
    width={250}
    height={30}
    title="Loading announcements"
    uniqueKey="announcement-header-skeleton-date"
    viewBox="0 0 250 30"
    {...DEFAULT_SETTINGS}>
    <rect width="250" height="30" rx="3" ry="3" />
  </ContentLoader>
);
